import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../config/axiosConfig';

import { Dropdown } from 'primereact/dropdown';
import { Avatar } from 'primereact/avatar';

import useSelectedCompanyStore from '../../../store/useSelectedCompanyStore';

const StepOne = ({ handleChange, inputText, isValid }) => {
    const selectedCompany = useSelectedCompanyStore((state) => state.selectedCompany);

    const [localInput, setLocalInput] = useState({
        campaign_name: inputText.campaign_name || '',
        language: inputText.language || 'Choisir une langue',
        recruiter: inputText.recruiter || ''
    });

    const [users, setUsers] = useState([]);
    const [usersRequestLoading, setUsersRequestLoading] = useState(false);

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            const msg = "Êtes vous sûrs de vouloir quitter cette page ? Tous ce qui a été écris jusqu'à maintenant sera supprimé.";
            e.preventDefault();
            e.returnValue = msg;
            return msg;
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    useEffect(() => {
        validateInputs(localInput);
    }, [localInput]);

    useEffect(() => {
        if (selectedCompany?.company_id) {
            fetchUsers();
        }
    }, [selectedCompany?.company_id]);

    const fetchUsers = async () => {
        setUsersRequestLoading(true);
        try {
            const response = await axiosInstance.get(`/dashboard/companies/${selectedCompany?.company_id}/users/list`);
            const items = response.data.items.map(item => ({
                label: item.display_name || `${item.first_name} ${item.last_name || ''}`,
                first_name: item.first_name,
                last_name: item.last_name,
                value: item.user_id,
                avatar: item.profile_picture ? `/dashboard/user/avatar/${item.profile_picture}` : null
            }));
            setUsers(items);
        } catch (error) {
            console.error('Failed to fetch users:', error);
        } finally {
            setUsersRequestLoading(false);
        }
    };

    const handleLocalChange = (key, value) => {
        setLocalInput(prev => ({ ...prev, [key]: value }));
    };

    const validateInputs = (inputs) => {
        const is_valid = Object.values(inputs).every(value => value && value !== 'Choisir une langue');
        handleChange(inputs);
        isValid(is_valid ? { step: '0' } : false);
    };

    const userTemplate = (option) => {
        return (
            <div className="is-flex is-align-items-center">
                {option.avatar ? (
                    <Avatar
                        image={`/dashboard/user/avatar/${option.avatar}`}
                        className="ml-auto mr-3"
                        size="large"
                        shape="circle"
                    />
                ) : (
                    <div className="deepsy-anonymous-avatar m-2">
                        <span className='has-text-dgrad-deepsy'>{option.first_name[0].toUpperCase()}{option.last_name[0].toUpperCase()}</span>
                    </div>
                )}

                <span style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>{option.label}</span>
            </div>
        );
    };

    return (
        <div>
            <div className="columns">

                <div className="column">
                    <label className="label">Nom de la campagne</label>
                    <input
                        className="input"
                        type="text"
                        placeholder="Développeur Web FullStack H/F"
                        value={localInput.campaign_name}
                        onChange={(e) => handleLocalChange('campaign_name', e.target.value)}
                    />
                </div>

                <div className="column">
                    <label className="label">Entreprise</label>
                    <input
                        className="input"
                        type="text"
                        placeholder="DeePsy"
                        value={selectedCompany?.name}
                        readOnly
                        disabled
                    />
                </div>

            </div>

            <div className="columns">

                <div className="column">
                    <label className="label">Langue</label>
                    <Dropdown
                        className='is-fullwidth'
                        value={localInput.language}
                        options={[{ label: '🇫🇷 Français', value: 'fr' }, { label: '🇬🇧 English', value: 'en' }]}
                        onChange={(e) => handleLocalChange('language', e.value)}
                        placeholder="Langue de la campagne"
                    />
                </div>

                <div className="column">
                    <label className="label">Responsable en charge de la campagne</label>
                    {usersRequestLoading ? (
                        <Dropdown
                            className='is-fullwidth'
                            placeholder="Chargement..."
                            disabled
                            readOnly
                        />
                    ) : (
                        <Dropdown
                            className='is-fullwidth'
                            value={localInput.recruiter}
                            options={users}
                            onChange={(e) => {
                                handleLocalChange('recruiter', e.value);
                                handleLocalChange('recruiter_label', users.find(user => user.value === e.value).label);
                            }}
                            placeholder="Sélectionner une personne"
                            filter
                            filterInputAutoFocus
                            itemTemplate={userTemplate}
                        />
                    )}
                </div>

            </div>
        </div>
    );
};

export default StepOne;